var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7811 22.7187L17.1697 16.0425C18.5855 14.3451 19.4377 12.1563 19.4377 9.76609C19.4377 4.37234 15.1043 0 9.7304 0C4.35648 0 0 4.37232 0 9.76569C0 15.1591 4.35653 19.5314 9.7304 19.5314C12.1834 19.5314 14.4181 18.618 16.1239 17.1149L22.7237 23.7803C23.0156 24.0732 23.4892 24.0732 23.7807 23.7803C24.073 23.4869 24.073 23.0121 23.7811 22.7187ZM9.71778 18.0055C5.19643 18.0055 1.4951 14.2907 1.4951 9.75298C1.4951 5.21524 5.19643 1.5005 9.71778 1.5005C14.2391 1.5005 17.9405 5.21524 17.9405 9.75298C17.9405 14.2907 14.2391 18.0055 9.71778 18.0055ZM13.4554 9.00276H5.9802C5.56757 9.00276 5.23269 9.33886 5.23269 9.75298C5.23269 10.1671 5.56757 10.5032 5.9802 10.5032H13.4554C13.868 10.5032 14.2029 10.1671 14.2029 9.75298C14.2029 9.33886 13.8684 9.00276 13.4554 9.00276Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutIcon);
export default __webpack_public_path__ + "static/media/ZoomOutIcon.419385b1.svg";
export { ForwardRef as ReactComponent };